export default {
  TOKEN: 'token',
  TOKEN_EXPIRATION: 'token.expiration',
  LOGIN: 'login',
  ROLE: 'role',

  VERSION: '_VERSION',

  FILE_MODE: 'file-explorer-mode'
}
